import { UserType } from '../user-type.enum';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastService } from '../toast.service';

type DashboardCardIcon = 'eye' | 'eye-off' | 'dashboard' | 'users' | 'store' | 'user' | 'doc' | 'card' | 'dollar' | 'user-circle' | 'bell' | 'arrow-up';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, SidebarComponent, DashboardCardComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  cards: { title: string; value: string; sub: string; icon: DashboardCardIcon }[] = [];
  loading = false;
  errorMsg = '';
  userType = '';

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.userType = user.user_type?.toLowerCase() || '';
      } catch {}
    }

    // Call different APIs based on user type
    if (this.userType === 'admin' || this.userType === 'super_admin') {
      this.fetchAdminStats();
    } else if (this.userType === 'distributor') {
      this.fetchDistributorStats();
    } else if (this.userType === 'staff') {
      this.fetchStaffStats();
    }
  }

  fetchAdminStats() {
    this.loading = true;
    this.errorMsg = '';
    
    this.http.get<any>(`${environment.apiBaseUrl}/admin/analytics`).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data) {
          this.errorMsg = '';
          this.cards = [
            { title: 'Total Distributors', value: String(res.data.total_distributors || 0), sub: '', icon: 'users' },
            { title: 'Active Retailers', value: String(res.data.active_retailers || 0), sub: '', icon: 'store' },
            { title: 'Pending Invoices', value: String(res.data.pending_invoices || 0), sub: '', icon: 'doc' },
            { title: 'Total Transactions', value: String(res.data.total_transactions || 0), sub: '', icon: 'card' },
            { title: 'Revenue Growth', value: `${res.data.revenue_growth || 0}%`, sub: '', icon: 'arrow-up' },
            { title: 'Average Purchase', value: `₹${(res.data.average_purchase || 0).toLocaleString()}`, sub: '', icon: 'dollar' },
          ];
        } else {
          this.errorMsg = res.message || 'Failed to fetch stats';
          this.toastService.error(res.message || 'Failed to fetch stats');
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Failed to fetch stats';
        this.toastService.error(err?.error?.message || 'Failed to fetch stats');
      }
    });
  }

  fetchDistributorStats() {
    this.loading = true;
    this.errorMsg = '';
    
    this.http.get<any>(`${environment.apiBaseUrl}/distributor/analytics`).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data) {
          this.errorMsg = '';
          this.cards = [
            { title: 'My Retailers', value: String(res.data.my_retailers || 0), sub: '', icon: 'store' },
            { title: 'Active Orders', value: String(res.data.active_orders || 0), sub: '', icon: 'doc' },
            { title: 'Pending Payments', value: `₹${(res.data.pending_payments || 0).toLocaleString()}`, sub: '', icon: 'card' },
            { title: 'Monthly Revenue', value: `₹${(res.data.monthly_revenue || 0).toLocaleString()}`, sub: '', icon: 'dollar' },
            { title: 'New Retailers', value: String(res.data.new_retailers || 0), sub: '', icon: 'user' },
            { title: 'Average Order', value: `₹${(res.data.average_order || 0).toLocaleString()}`, sub: '', icon: 'arrow-up' },
          ];
        } else {
          this.errorMsg = res.message || 'Failed to fetch stats';
          this.toastService.error(res.message || 'Failed to fetch stats');
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Failed to fetch stats';
        this.toastService.error(err?.error?.message || 'Failed to fetch stats');
      }
    });
  }

  fetchStaffStats() {
    this.loading = true;
    this.errorMsg = '';

    this.http.get<any>(`${environment.apiBaseUrl}/staff/dashboard`).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.statusCode === 200 && res.data) {
          this.errorMsg = '';
          this.cards = [
            { title: 'Total Distributors', value: String(res.data.total_distributors || 0), sub: '', icon: 'users' },
            { title: 'Total Retailers', value: String(res.data.total_retailers || 0), sub: '', icon: 'store' },
          ];
        } else {
          this.errorMsg = res.message || 'Failed to fetch stats';
          this.toastService.error(res.message || 'Failed to fetch stats');
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMsg = err?.error?.message || 'Failed to fetch stats';
        this.toastService.error(err?.error?.message || 'Failed to fetch stats');
      }
    });
  }

  hasError(): boolean {
    return !!this.errorMsg;
  }
}
